import React, { Component } from 'react';
import { Route, RouteComponentProps, withRouter } from 'react-router-dom';
import {
  selectMenu,
  selectMeta
} from '../../provider/Typo3Provider/selectors';
import {
  withTypo3,
  WithTypo3Props
} from '../../provider/Typo3Provider/withTypo3';

class IfSocialLinksAvailable extends Component<
  WithTypo3Props & RouteComponentProps
  > {
  public render = () => {
    const meta = selectMeta(this.props.typo3);

    if (!meta) {
      return null;
    }

    const [watchListEntry] = selectMenu(this.props.typo3, 'watchlist');
    if (!watchListEntry) {
      return null;
    }

    const {link} = watchListEntry;

    return (
      <Route
        path={link}
        children={({match}) => !match && this.props.children}
      />
    );
  }
}

export default withRouter(withTypo3(IfSocialLinksAvailable));
